import React from 'react';
import Seo from "../../../utils/seo/Seo";
import "./FAQ.css";

const FAQ = () => {
  return (
    <>
    <Seo
      title="Memorial Website FAQ — Plans, Privacy & Features"
      description="Answers about creating a memorial website, plans and pricing, privacy, picture frames, and sharing your online remembrance page."
      path="/faq"
    />
    <div className="cu-page">
      <div className="faq-top">
        <h1>Frequently Asked Questions</h1>
      </div>
    <div className="faq-container">
      

      <h2>Account and Access</h2>
      <div className="faq-item">
        <h3>1. Do I need a login to view a memorial page?</h3>
        <p>Yes, you will need to log in to view a memorial page. Creating an account provides you with access to all the memorial pages you’ve created or wish to visit.</p>
      </div>
      <div className="faq-item">
        <h3>2. Can I create more than one memorial page?</h3>
        <p>You can only create one memorial page per payment. If you wish to create multiple memorial pages, you will need to purchase additional plans.</p>
      </div>

      <h2>Plans and Pricing</h2>
      <div className="faq-item">
        <h3>3. What plans are available, and what features do they offer?</h3>
        <p>We offer three plans to suit different needs:</p>
        <ul>
          <li><strong>Free Plan:</strong> Limited access to memorial page features and functionalities. A great way to get started, but most features will be restricted.</li>
          <li><strong>$49.99 Plan:</strong> Full-featured memorial page including the ability to upload photos, videos, and personalized messages.</li>
          <li><strong>$69.99 Plan:</strong> Includes all features of the $49.99 plan, plus a beautiful white leather picture frame with the company logo "Will Always Love U".</li>
        </ul>
      </div>
      <div className="faq-item">
        <h3>4. How long will it take to receive the picture frame?</h3>
        <p>Delivery time depends on frame availability. We will contact you with shipping details once your order is processed.</p>
      </div>

      <h2>Customization and Features</h2>
      <div className="faq-item">
        <h3>5. Can I change or update my memorial page after it’s been created?</h3>
        <p>Yes, you can update your memorial page anytime, including adding or removing content like photos, videos, or text. To modify the theme, background music, or privacy settings, click on the Admin menu and select your option.</p>
      </div>
      <div className="faq-item">
        <h3>6. Can I share my memorial page with others?</h3>
        <p>Absolutely! Once your memorial page is created, you can share the URL with family and friends. They will need to log in to view the page. The page must be set to public for your friends to access it.</p>
      </div>
      <div className="faq-item">
        <h3>7. Is my memorial page private?</h3>
        <p>Yes, your memorial page is private by default.</p>
      </div>

      <h2>Support and Policies</h2>
      <div className="faq-item">
        <h3>8. What if I need help setting up or managing my memorial page?</h3>
        <p>If you need assistance, our support team is here to help! You can contact us through the website’s support section, and we’ll guide you through any issues.</p>
      </div>
      <div className="faq-item">
        <h3>9. Can I cancel or get a refund if I change my mind?</h3>
        <p>Since our services are personalized, we cannot offer refunds once the memorial page has been created. However, if you encounter any issues, please reach out to our support team, and we’ll do our best to resolve them.</p>
      </div>
      <div className="faq-item">
        <h3>10. What payment methods do you accept?</h3>
        <p>We accept major credit cards, debit cards, and other online payment methods.</p>
      </div>

      <h2>Technical Details</h2>
      <div className="faq-item">
        <h3>11. Which browser do you recommend for the best experience?</h3>
        <p>We recommend using Google Chrome for the best experience on our website. While other browsers may work, Chrome offers optimal performance, faster load times, and fewer potential issues.</p>
      </div>
      <div className="faq-item">
        <h3>12. When inviting friends or sharing a memorial page, it is not visible?</h3>
        <p>Make sure the memorial page is set to public and not private.</p>
      </div>
    </div>
    </div>
    </>
  );
};

export default FAQ;
